export default __webpack_public_path__ + "galaxy-store-icon.webp";